import AttributeBadge from './AttributeBadge';

export default AttributeBadge;